<template>
  <div class="applyInfo">
    <Headers></Headers>
    <div class="container">
      <div class="mainContainer">
        <div class="inner" ref="inner">
          <div class="breadcrumbs">
            <span @click="goIndex">招聘首页</span>
            <i class="el-icon-arrow-right"></i>
            <span @click="goList">职位列表</span>
            <i class="el-icon-arrow-right"></i>
            <span @click="goDetails">职位详情</span>
            <i class="el-icon-arrow-right"></i>
            <i class="">职位申请</i>
          </div>
          <div class="innerBox">
            <div class="title">
              <p>丘钛微电子科技集团</p>
              <p>{{jobTitle.category}}</p>
              <div class="multi">
                <div class="place">
                  <span>{{jobTitle.subCategory}}</span>
                  |
                  <span>{{jobTitle.baseCity}}</span>
                </div>
                <div class="time">发布时间：{{jobTitle.time.split(" ")[0]}}</div>
              </div>
            </div>
            <div class="detail">
              <div class="desc">
                <div class="item">
                  <p class="commonTitle special" id="apply">申请信息</p>
                  <el-row :gutter="30" class="recommendFlag">
                    <el-col :lg="8" :md="8" :xs="24"> 我司校招信息了解渠道： </el-col>
                    <el-col :lg="12" :md="12" :xs="18">
                      <el-select
                        v-model="recommendFlag"
                        placeholder="请选择渠道来源"
                      >
                        <el-option
                          v-for="(item, index) in channelSourceList"
                          :key="index"
                          :label="item.name"
                          :value="item.name"
                        >
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                  <div class="recommend" v-show="disabledFlag">
                    <div>
                      <span>{{renderText}}</span>
                    </div>
                    <el-row>
                      <el-col :span="24">
                        <el-input
                          v-model="recommendCode"
                          :placeholder=renderPlaceholder
                        ></el-input>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <el-form
                  ref="form"
                  :rules="rules"
                  class="former"
                  label-position="top"
                  :model="form"
                  label-width="100%"
                >
                  <p class="commonTitle" id="upload">上传</p>
                  <el-row :gutter="30">
                    <el-col :span="24">
                      <el-form-item required label="上传简历">
                        <el-upload
                          class="upload-demo"
                          drag
                          ref="upload"
                          :action="fileAction"
                          :limit="limitNum"
                          :before-upload="beforeUploadFile"
                          :on-change="fileChange"
                          :on-exceed="exceedFile"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          multiple
                        >
                          <i class="el-icon-upload"></i>
                          <div class="el-upload__text">
                            将文件拖到此处，或<em>点击上传</em>
                          </div>
                          <div class="el-upload__tip" slot="tip">
                            <!-- 、wps、txt、doc、pptx、ppt -->
                            简历大小不超过 <span style="color: red;">5M</span> ，支持pdf、docx、jpg、jpeg、png格式
                          </div>
                        </el-upload>
                      </el-form-item>
                    </el-col>                    
                  </el-row>
                  <p class="commonTitle personInfo" id="personInfo">基础信息</p>
                  <el-row :gutter="30">
                    <el-col :lg="12" :md="12" :xs="24">
                      <el-form-item label="姓名" prop="name">
                        <el-input
                          v-model="form.name"
                          clearable
                          placeholder="姓名"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :md="12" :xs="24">
                      <el-form-item label="性别" prop="sex">
                        <el-select
                          v-model="form.sex"
                          clearable
                          placeholder="请选择性别"
                        >
                          <el-option
                            v-for="(item, index) in sexList"
                            :key="index"
                            :label="item.name"
                            :value="item.name"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :md="12" :xs="24">
                      <el-form-item label="籍贯" prop="nativePlace">
                        <el-cascader
                          :options="options"
                          v-model="form.nativePlace"
                          @change="addressChange"
                          class="PVC"
                          size="large"
                        >
                        </el-cascader>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :md="12" :xs="24">
                      <el-form-item label="手机号" prop="telephone">
                        <el-input
                          v-model="form.telephone"
                          placeholder="姓名"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :md="12" :xs="24">
                      <el-form-item label="邮箱" prop="email">
                        <el-input
                          v-model="form.email"
                          placeholder="请输入邮箱"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <p class="commonTitle" id="education">教育信息</p>
                  <el-row :gutter="30">
                    <el-col :lg="12" :md="12" :xs="24">
                      <el-form-item label="学校名称" prop="schoolName">
                        <el-input
                          v-model="form.schoolName"
                          clearable
                          placeholder="学校名称"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :md="12" :xs="24">
                      <el-form-item label="学历" prop="education">
                        <el-select
                          v-model="form.education"
                          clearable
                          placeholder="请选择学历"
                        >
                          <el-option
                            v-for="(item, index) in eduList"
                            :key="index"
                            :label="item.typeOption"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :md="12" :xs="24">
                      <el-form-item label="学习类型" prop="studyType">
                        <el-select
                          v-model="form.studyType"
                          clearable
                          placeholder="请选择学习类型"
                        >
                          <el-option
                            v-for="(item, index) in studyTypeList"
                            :key="index"
                            :label="item.name"
                            :value="item.name"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :md="12" :xs="24">
                      <el-form-item label="学校类别" prop="schoolType">
                        <el-select
                          v-model="form.schoolType"
                          clearable
                          placeholder="请选择学校类别"
                        >
                          <el-option
                            v-for="(item, index) in schoolTypeList"
                            :key="index"
                            :label="item.typeOption"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :md="12" :xs="24">
                      <el-form-item label="专业名称" prop="major">
                        <el-select
                          v-model="form.major"
                          clearable
                          filterable
                          placeholder="请选择专业名称"
                        >
                          <el-option
                            v-for="(item, index) in majorList"
                            :key="index"
                            :label="item.majorType + ' - ' + item.majorName"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :md="12" :xs="24">
                      <el-form-item label="学习成绩排名" prop="record">
                        <el-select
                          v-model="form.record"
                          clearable
                          placeholder="请选择学习成绩排名"
                        >
                          <el-option
                            v-for="(item, index) in recordList"
                            :key="index"
                            :label="item.name"
                            :value="item.name"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :md="12" :xs="24">
                      <el-form-item label="英语水平" prop="english">
                        <el-select
                          v-model="form.english"
                          clearable
                          placeholder="请选择英语水平"
                        >
                          <el-option
                            v-for="(item, index) in engList"
                            :key="index"
                            :label="item.typeOption"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :md="12" :xs="24">
                      <el-form-item label="是否挂科" prop="fail">
                        <el-select
                          v-model="form.fail"
                          clearable
                          placeholder="请选择是否挂科"
                        >
                          <el-option
                            v-for="(item, index) in decideList"
                            :key="index"
                            :label="item.name"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  
                  <p class="commonTitle" id="wanted">求职意向</p>
                  <el-row :gutter="30">
                    <el-col :lg="12" :md="12" :xs="24">
                      <el-form-item label="岗位是否服从调剂" prop="obey">
                        <el-select
                          v-model="form.obey"
                          clearable
                          placeholder="请选择是否服从调剂"
                        >
                          <el-option
                            v-for="(item, index) in decideList"
                            :key="index"
                            :label="item.name"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
                <div class="submitBtn">
                  <el-button type="primary" @click="submitForm('form')"
                    >提交</el-button
                  >
                </div>
              </div>
              <div :class="fixedClass" ref="category">
                <ul>
                  <li
                    :class="{ active: index == current }"
                    v-for="(item, index) in labelList"
                    :key="index"
                    @click="goto(item.path, index)"
                  >
                    {{ item.name }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer></Footer>

    <el-dialog
      :visible.sync="codeFlag"
      top="200px"
      class="dialogTopper"
      :before-close="handleClose"
    >
      <span class="circle"></span>
      <img src="@/assets/image/shield.png" alt="" />
      <el-form
        ref="form2"
        :rules="rule2"
        class="codeDialog"
        label-position="top"
        :model="form2"
        label-width="100%"
      >
        <div class="title">
          <span>手机号验证</span>
        </div>
        <el-row class="tel">
          <el-form-item prop="tel" class="telItem">
            <i class="el-icon-phone-outline"></i>
            <el-input
              v-model="form2.tel"
              clearable
              maxlength="11"
              placeholder="请输入手机号"
              @input="verifyTelephone"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row class="code">
          <el-col :span="16">
            <el-form-item prop="code" class="codeItem">
              <i class="el-icon-key"></i>
              <el-input
                v-model="form2.code"
                maxlength="6"
                @input="verifyCode"
                placeholder="请输入验证码"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <div>
              <el-button v-show="codeTextFlag" @click="increaseNumber"
                >获取验证码</el-button
              >
              <el-button type="primary" plain disabled v-show="!codeTextFlag"
                >{{ this.seconds }}<i> 秒</i> 后重发</el-button
              >
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :disabled="verifyFlag" @click="handleAccess"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
  
<script>
import Headers from "@/components/Headers.vue";
import Footer from "@/components/Footer.vue";
import { regionData, CodeToText } from "element-china-area-data";

export default {
  name: "applyInfo",
  components: { Headers, Footer },
  data() {
    const checkEmail = (rule, value, callback) => {
      let reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      setTimeout(() => {
        if (value && !reg.test(value)) {
          callback(new Error("请输入正确的邮箱"));
        } else {
          callback();
        }
      }, 1000);
    };
    const checkTelephone = (rule, value, callback) => {
      let reg = /^1([38][0-9]|4[014-9]|[59][0-35-9]|6[2567]|7[0-8])\d{8}$/;
      setTimeout(() => {
        if (value && !reg.test(value)) {
          callback(new Error("请输入正确的手机号"));
        } else {
          callback();
        }
      }, 1000);
    };
    return {
      channelSourceList:[
        {
          value: 1,
          name: "前程无忧"
        },
        {
          value: 2,
          name: "猎聘网"
        },
        {
          value: 3,
          name: "智联招聘"
        },
        {
          value: 4,
          name: "校园大使"
        },
        {
          value: 5,
          name: "内部推荐"
        },
        {
          value: 6,
          name: "宣讲会"
        },
        {
          value: 7,
          name: "培训机构"
        },
        {
          value: 8,
          name: "人才市场"
        },
        {
          value: 9,
          name: "老师推荐"
        },
        {
          value: 10,
          name: "学校就业网"
        },
        {
          value: 11,
          name: "其它"
        }
      ],
      renderText:'',
      renderPlaceholder:'',
      jobId:0,
      fileAction: this.axios.defaults.baseURL + "/apis/common/upload",
      attachment: "", // 附件地址
      suffix:"", //附件类型
      jobName:"", // router 参数
      jobTitle:{},
      limitNum: 1, // 上传限制
      fileList: [], // 上传图片 列表
      options: regionData,
      personalForm: {
        //表单
        lng: "", //经度 && 维度
        lat: "",
        shopAdressProvince: "", //省市区名称
        shopAdressCity: "",
        adname: "",
        prcode: "", //省市区code码
        citycode: "",
        adcode: "",
      },
      codeDisable: true, // 验证码时间 失效
      codeTextFlag: true, // 获取验证码 文字
      timer: null, // 验证码 定时器
      seconds: 60, // 验证码提交时间
      codeFlag: false, // 验证码模态框 状态
      recommendFlag: "", // 渠道
      disabledFlag: false, // 推荐码 状态
      imageUrl: "", // 上传图片
      form: {
        name: "",
        sex: "",
        nativePlace: [],
        telephone: "",
        email: "",
        record: "",
        english: "",
        education: "",
        studyType: "",
        schoolType: "",
        schoolName: "",
        major: "",
        fail: "",
        obey: "",
        channel: "",
      }, // 简历表单
      form2: {
        tel: "",
        code: "",
      }, // 验证码 表单
      verifyFlag: true, // 是否验证成功 允许提交申请
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 2, max: 20, message: "长度在 2 到 20 个字符", trigger: "blur" },
        ],
        telephone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: checkTelephone, trigger: "blur" },
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { validator: checkEmail, trigger: "blur" },
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        record: [
          { required: true, message: "请选择学习成绩排名", trigger: "change" },
        ],
        nativePlace: [
          { required: true, message: "请选择籍贯", trigger: "change" },
        ],
        english: [
          { required: true, message: "请选择英语水平", trigger: "change" },
        ],
        education: [
          { required: true, message: "请选择学历", trigger: "change" },
        ],
        studyType: [
          { required: true, message: "请选择学习类型", trigger: "change" },
        ],
        schoolType: [
          { required: true, message: "请选择学校类别", trigger: "change" },
        ],
        schoolName: [
          { required: true, message: "请输入学校名称", trigger: "blur" },
          { min: 2, max: 20, message: "长度在 2 到 20 个字符", trigger: "blur" },
        ],
        major: [
          { required: true, message: "请选择专业名称", trigger: "change" },
        ],
        fail: [
          { required: true, message: "请选择是否挂科", trigger: "change" },
        ],
        obey: [
          { required: true, message: "请选择是否服从调剂", trigger: "change" },
        ],
        channel: [
          { required: true, message: "请选择是否来源内荐", trigger: "change" },
        ],
      }, // 简历表单 规则
      rule2: {
        tel: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          // { min: 2, max: 8, message: "长度在 2 到 8 个字符", trigger: "blur" },
          { validator: checkTelephone, trigger: "blur" },
        ],
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          // { min: 0, max: 6, message: "长度在 2 到 8 个字符", trigger: "blur" },
          // { validator: checkEmail, trigger: "blur" },
        ],
      }, // 简历表单 规则
      majorList: [], // 专业列表
      sexList: [
        {
          value: 1,
          name: "男",
        },
        {
          value: 2,
          name: "女",
        },
      ], // 性别列表
      decideList: [
        {
          value: 1,
          name: "是",
        },
        {
          value: 0,
          name: "否",
        },
      ], // 选择 列表
      recordList: [
        {
          value: 1,
          name: "前5%",
        },
        {
          value: 2,
          name: "前20%",
        },
        {
          value: 3,
          name: "前50%",
        },
      ], // 学习成绩排名 列表
      engList: [], // 英语水平 列表
      eduList: [], // 学历 列表
      studyTypeList: [
        {
          value: 1,
          name: "全日制",
        },
        {
          value: 2,
          name: "专升本",
        },
      ], // 学习类型 列表
      schoolTypeList: [], // 学校类别 列表
      myClass: "msg msgHide", // popover 样式
      recommendCode: "", // 推荐码
      scrollHeight: 0,
      fixedClass: "category", // 右侧栏目 样式
      current: 0, // 右侧栏目 index
      labelList: [
        {
          id: 1,
          name: "申请信息",
          path: "apply",
        },
        {
          id: 2,
          name: "上传",
          path: "upload",
        },
        {
          id: 3,
          name: "基础信息",
          path: "personInfo",
        },
        {
          id: 4,
          name: "教育信息",
          path: "education",
        },
        {
          id: 5,
          name: "求职意向",
          path: "wanted",
        }
      ],
    }; // 右侧 栏目
  },
  mounted() {
    window.addEventListener("scroll", this.scrollHandle); //绑定页面滚动事件
    // 监听滚动事件
    window.addEventListener("scroll", this.onScroll, false);
  },
  created(){
    // this.jobName = this.$route.query.jobName.replace(" ","+");
    this.jobId = this.$route.query.id;
    this.getDetail(this.jobId);
    // this.getJobId(this.jobName);
    this.getMajorList();
    this.getEnglishLevel();
    this.getEducation();
    this.getStudyType();
  },
  watch: {
    scrollHeight() {
      if (this.scrollHeight > 170) {
        let width = this.$refs['inner'].getBoundingClientRect().right - 180;
        this.$refs.category.style.left = width + "px";
        this.$refs.category.style.position = "fixed";
        this.$refs.category.style.top = "80px";
      } else {
        this.$refs.category.style.left = "700px";
        this.$refs.category.style.position = "absolute";
        this.$refs.category.style.top = "32px";
      }
    },
    recommendFlag() {
      if (this.recommendFlag == "内部推荐" || this.recommendFlag == "其它") {
        this.disabledFlag = true;
        if(this.recommendFlag == "内部推荐"){
          this.renderText = '推荐人工号';
          this.renderPlaceholder = '请输入推荐人工号';
        }else if (this.recommendFlag == "其它"){
          this.renderText = '其它渠道';
          this.renderPlaceholder = '请输入具体渠道';
        }
      } else {
        this.disabledFlag = false;
      }
    },
  },
  methods: {
    getEducation(){
      let params = {
        basicType: '学历'
      }
      this.axios({
        url: "/apis/resume/basicInfo",
        method: "get",
        params: params,
      }).then((res) => {
        if (res.code == 200) {
          let data = res.rows;
          this.eduList = data;
        } else {
          this.eduList = [];
        }
      });
    },
    getStudyType(){
      let params = {
        basicType: '学校类别'
      }
      this.axios({
        url: "/apis/resume/basicInfo",
        method: "get",
        params: params,
      }).then((res) => {
        if (res.code == 200) {
          let data = res.rows;
          this.schoolTypeList = data;
        } else {
          this.schoolTypeList = [];
        }
      });
    },
    getEnglishLevel(){
      let params = {
        basicType: '英文水平'
      }
      this.axios({
        url: "/apis/resume/basicInfo",
        method: "get",
        params: params,
      }).then((res) => {
        if (res.code == 200) {
          let data = res.rows;
          this.engList = data;
        } else {
          this.engList = [];
        }
      });
    },
    // getJobId(jobName){
    //   let params = {
    //     jobName: jobName
    //   }
    //   this.axios({
    //     url: "/apis/job/list",
    //     method: "get",
    //     params: params,
    //   }).then((res) => {
    //     if (res.code == 200) {
    //       let data = res.rows[0];
    //       this.jobId = data.id;
    //     } else {
    //       this.jobId = 0;
    //     }
    //   });
    // },
    exceedFile(files, fileList) {
      this.$message.warning({
        title: "警告",
        message: `只能选择 ${this.limitNum} 个文件，当前共选择了 ${
          files.length + fileList.length
        } 个`,
      });
    },
    fileChange(file, fileList) {
      this.fileList = fileList;
    },
    beforeUploadFile(file) {
      const supportFileTypesList = ["pdf", "docx", "jpg","jpeg","png"];
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      const isSupportFileType = supportFileTypesList.includes(extension);
      let size = file.size / 1024 / 1024;
      if (!isSupportFileType) {
        this.$message.warning({
          title: "警告",
          message: `请上传指定格式的简历`,
        });
      }
      if (size > 5) {
        this.$message.warning({
          title: "警告",
          message: `文件大小不得超过5M`,
        });
      }
      return isSupportFileType && size < 5;
    },
    // 文件上传成功
    handleSuccess(res, file, fileList) {
      this.fileList = fileList;
      this.attachment = res.fileName;
      this.suffix = res.suffix.split(".")[1];
      this.$message.success({
        title: "成功",
        message: `简历上传成功`,
      });
    },
    handleError(err, file, fileList) {
      this.$message.error({
        title: "错误",
        message: `简历上传失败`,
      });
    },
    getMajorList(){
      let params = {
        current:1,
        pageSize:1000
      };
      this.axios({
        url: "/apis/major/list",
        method: "get",
        params: params,
      }).then((res) => {
        if (res.code == 200) {
          this.majorList = res.rows;
        } else {
          this.majorList = [];
        }
      });
    },
    getDetail(id){
      this.axios({
        url: "/apis/job/info/" + id,
        method: "get",
      }).then((res) => {
        if (res.code == 200) {
          let data = res.data;
          this.jobTitle = {
            baseCity: data.workCity, //工作城市
            category: data.jobType, //主分类
            subCategory: data.jobName, // 子分类
            time: data.createTime
          }
        } else {
          this.jobTitle = {};
        }
      });
    },
    handleClose(){
      this.resetForm('form2');
      this.codeFlag = !this.codeFlag;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    verifyTelephone() {
      let value = this.form2.tel;
      let reg = /^1([38][0-9]|4[014-9]|[59][0-35-9]|6[2567]|7[0-8])\d{8}$/;
      if (value && !reg.test(value)) {
        // this.$message.error("请输入正确的手机号");
      } else {
        this.codeTextFlag = true;
        this.codeDisable = false;
      }
    },
    verifyCode() {
      if (this.form2.code.length == 6) {
        this.verifyFlag = false;
      }else{
        this.verifyFlag = true;
      }
    },
    getCode(){
      this.axios({
        url: "/apis/pin/code/" + this.form2.tel,
        method: "get"
      }).then((res) => {
        if (res.code == 200) {
          this.$message.success("验证码已发送！");
        } else {
          this.$message.error("验证码发送失败请重试！");          
        }
      });
    },
    checkCode() {
      let params = {
        phoneNumber: this.form2.tel,
        code: this.form2.code
      }
      this.axios({
        url: "/apis/pin/confirm/",
        method: "POST",
        data: params
      }).then((res) => {
        if (res.code == 200) {
          this.handleSubmit();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // addressClear(){
    //   this.form.nativePlace = "";
    // },
    //选择省市区时-将取到的省市区名称、编码赋值给要传给后台的表单
    addressChange(arr) {
      //change事件
      this.personalForm.shopAdress = `${CodeToText[arr[0]]}-${
        CodeToText[arr[1]]
      }-${CodeToText[arr[2]]}`; //根据后台接参，这里传的是河北省-石家庄市-桥西区形式。下面是分开传的省市区文字和编码。
      this.personalForm.shopAdressProvince = CodeToText[arr[0]]; //省市区名称
      this.personalForm.shopAdressCity = CodeToText[arr[1]];
      this.personalForm.adname = CodeToText[arr[2]];
      this.personalForm.prcode = arr[0]; //省市区编码
      this.personalForm.citycode = arr[1];
      this.personalForm.adcode = arr[2];
      console.log(this.personalForm);
      // this.selectedOptions = [ [arr[0],[arr[1],[arr[2] ]
      this.form.nativePlace = [arr[0], arr[1], arr[2]];
      // this.form.nativePlace = this.personalForm.shopAdress;
      // 城市提交给地图
      // this.MapCityName = [CodeToText[arr[0]], CodeToText[arr[1]] , CodeToText[arr[2]] ];
    },
    // 验证码发送
    increaseNumber() {
      let value = this.form2.tel;
      let reg = /^1([38][0-9]|4[014-9]|[59][0-35-9]|6[2567]|7[0-8])\d{8}$/;
      if (value == "" || !reg.test(value)) {
        this.$message.error("请输入正确的手机号");
        return false
      }
      this.getCode();
      this.codeTextFlag = false;
      this.codeDisable = !this.codeDisable;
      if (this.seconds <= 0) {
        return;
      }
      let _this = this;
      this.timer = setInterval(function () {
        // this.seconds = --this.seconds;
        _this.seconds = --_this.seconds;
        if (_this.seconds < 0) {
          _this.codeDisable = !_this.codeDisable;
          _this.codeTextFlag = true;
          _this.timeUp();
          return;
        }
      }, 1000);
    },
    timeUp() {
      clearInterval(this.timer);
      this.seconds = 60;
    },
    handleAccess() {
      this.checkCode();
    },
    showDialog() {
      this.codeFlag = !this.codeFlag;
    },
    handleAvatarSuccess() {},
    beforeAvatarUpload() {},
    goIndex() {
      this.$router.push("/index");
    },
    goList() {
      this.$router.push("/recruitList");
    },
    goDetails() {
      this.$router.push('/recruitDetails?id=' + this.jobId);
    },
    submitForm(formName) {
      if(!this.recommendFlag){
        this.$message.warning("请选择来源渠道！");
        return false;
      }
      if(this.recommendFlag == "内部推荐" && this.recommendCode == ""){
        this.$message.warning("请输入推荐人工号！");
        return false;
      }
      if(this.recommendFlag == "其它" && this.recommendCode == ""){
        this.$message.warning("请输入其它来源渠道！");
        return false;
      }
      if(this.fileList.length == 0){
        this.$message.warning("请上传简历！");
        return false;
      }
      // this.codeTextFlag = true;
      // this.timeUp();
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            phoneNumber: this.form.telephone
          }
          this.axios({
            url: "/apis/resume/list",
            method: "get",
            params: params,
          }).then((res) => {
            if (res.code == 200) {
              if(res.rows.length > 0){
                this.$message.warning("您已提交过简历申请，无需重复提交！")
              }else{
                this.form2.tel = "";
                this.form2.code = "";
                // this.resetForm('form2');
                this.showDialog();
              }
              // this.$message.success("提交成功！");
            } else {
              // this.$message.error("提交失败！");
            }
          });
          // this.form2.tel = "";
          // this.form2.code = "";
          // // this.resetForm('form2');
          // this.showDialog();
        } else {
          return false;
        }
      });
    },
    handleSubmit(){
      let params = {
        jobId: this.jobId,
        nickName: this.form.name,
        sex: this.form.sex,
        nativePlace: this.personalForm.shopAdress,
        email: this.form.email,
        phoneNumber: this.form.telephone,
        scoreRanking: this.form.record,
        englishLevelId: this.form.english,
        educationId: this.form.education,
        learnType: this.form.studyType,
        schoolCategoryId: this.form.schoolType,
        school: this.form.schoolName,
        majorId: this.form.major,
        ifFail: this.form.fail,
        ifObeyAdjust: this.form.obey,
        // ifRecommend: this.recommendFlag,
        channelSource: this.recommendFlag,
        recommendCode: this.recommendCode,
        attachment: this.attachment,
        suffix: this.suffix
      }
      this.axios({
        url: "/apis/resume/add",
        method: "post",
        data: params,
      }).then((res) => {
        if (res.code == 200) {
          this.$message.success("提交成功！");
          this.resetForm('form');
          this.recommendFlag = "";
          this.recommendCode = "";
          this.fileList = [];
          this.$refs['upload'].clearFiles();
          this.codeFlag = false;
          this.form2.tel = "";
          this.form2.code = "";
          this.resetForm('form2');
        } else {
          this.$message.error("提交失败！");
        }
      });
    },
    // 滚动监听器
    onScroll() {
      // 获取所有锚点元素
      const navContents = document.querySelectorAll(".commonTitle");
      // 所有锚点元素的 offsetTop
      const offsetTopArr = [];
      navContents.forEach((item) => {
        offsetTopArr.push(item.offsetTop);
      });
      // 获取当前文档流的 scrollTop
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 定义当前点亮的导航下标
      let navIndex = 0;
      for (let n = 0; n < offsetTopArr.length; n++) {
        // 如果 scrollTop 大于等于第n个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
        // 那么此时导航索引就应该是n了
        if (scrollTop >= offsetTopArr[n]) {
          navIndex = n;
        }
      }
      this.current = navIndex;
    },
    scrollHandle(e) {
      this.scrollHeight = e.srcElement.scrollingElement.scrollTop; // 获取页面滚动高度
    },
    showMsg() {
      this.myClass = "msg msgShow";
    },
    hideMsg() {
      this.myClass = "msg msgHide";
    },
    goUpload() {},
    goto(name, index) {
      this.current = index;
      var element = document.getElementById(name);
      var headerOffset = 100;
      var elementPosition =
        element.getBoundingClientRect().top + window.scrollY;
      var offsetPosition = elementPosition - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
  
<style lang="scss" scoped>
.applyInfo {
  background-color: #f4f4f4;
  @media (max-width: 1200px) {
    padding-bottom: 0px;
  }
  .container {
    position: relative;
    min-width: 970px;
    max-width: 1200px;
    padding-top: 60px;
    margin: 0 auto 100px;
    @media (max-width: 1200px) {
      min-width: 100%;
      max-width: 100%;
      margin: 0 auto 30px;
    }
    .mainContainer {
      width: 100%;
      display: -webkit-box;
      display: -webkit-flex;
      display: -moz-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: horizontal;
      -webkit-box-direction: normal;
      -webkit-flex-direction: row;
      -moz-box-orient: horizontal;
      -moz-box-direction: normal;
      -ms-flex-direction: row;
      flex-direction: row;
      -webkit-flex-wrap: wrap;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      -moz-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      min-width: 1200px;
      margin: 0;
      overflow: auto;
      @media (max-width: 1200px) {
        min-width: 100%;
      }
      .inner {
        width: 880px;
        -webkit-box-flex: 0;
        -webkit-flex: none;
        -moz-box-flex: 0;
        -ms-flex: none;
        flex: none;
        margin-right: 20px;
        @media (max-width: 1200px) {
          width: 100%;
          margin-right: 0;
          .item {
            padding: 0;
          }
        }
        .breadcrumbs {
          min-width: 970px;
          max-width: 1200px;
          margin: 0 auto;
          padding: 1rem 0;
          font-size: 0.85em;
          text-align: left;
          @media (max-width: 1200px) {
            min-width: 100%;
            max-width: 100%;
            padding-left: 15px;
          }
          span {
            color: #1890ff;
            cursor: pointer;
            &:last-child {
              color: #141933;
            }
          }
        }
        .innerBox {
          position: relative;
          min-height: 740px;
          padding-bottom: 50px;
          -webkit-border-radius: 2px;
          -moz-border-radius: 2px;
          border-radius: 2px;
          background-color: #fff;
          color: #474c66;
          .title {
            padding: 32px 40px 16px 40px;
            border-bottom: 1px solid #e6e8f2;
            text-align: left;
            @media (max-width: 1200px) {
              padding: 15px;
            }
            p {
              margin: 0;
              &:nth-child(1) {
                margin-bottom: 7px;
                color: #989cb2;
                font-weight: bold;
                font-size: 14px;
                line-height: 1;
                text-align: left;
              }
              &:nth-child(2) {
                width: 100%;
                font-size: 20px;
                line-height: 30px;
              }
            }
            .multi {
              margin-top: 8px;
              color: #474c66;
              font-size: 16px;
              line-height: 24px;
              @media (max-width: 1200px) {
                height: auto;
              }
              .place {
                vertical-align: middle;
                margin-right: 12px;
                padding-right: 12px;
                @media (max-width: 1200px) {
                  float: none;
                }
              }
              .time {
                vertical-align: middle;
                color: #989cb2;
                font-size: 14px;
                @media (max-width: 1200px) {
                  float: none;
                }
              }
            }
          }
          .detail {
            position: relative;
            padding-top: 32px;
            > .desc {
              width: 600px;
              margin: 0 0 0 30px;
              @media (max-width: 1200px) {
                width: 100%;
                margin: 0;
                .el-row {
                  margin: 0 !important;
                  .el-col {}
                }
              }
              .commonTitle {
                text-align: left;
                border-bottom: 1px solid #e6e8f2;
                font-weight: bold;
                font-size: 16px;
                margin: 30px 0 0 0;
                @media (max-width: 1200px) {
                  font-size: 14px;
                  margin: 15px 15px;
                }
                &.special {
                  margin-top: 0px;
                }
              }
              .recommendFlag {
                margin-top: 20px;
                line-height: 40px;
                > div {
                  &:first-of-type {
                    text-align: left;
                    @media (max-width: 1200px) {
                      text-align: left;
                      padding-left: 15px !important;
                    }
                  }
                }
              }
              .recommend {
                padding: 15px 15px 15px 0;
                @media (max-width: 1200px) {
                  padding: 15px;
                }
                width: 75%;
                > div {
                  &:first-of-type {
                    height: 30px;
                    line-height: 25px;
                    white-space: pre-wrap;
                    white-space: pre-wrap;
                    word-break: break-all;
                    word-break: break-all;
                    text-align: left;
                    position: relative;
                    span {
                      vertical-align: middle;
                    }
                    i {
                      float: right;
                      vertical-align: middle;
                      line-height: 25px;
                      font-size: 20px;
                      width: 20px;
                      height: 21px;
                    }
                    img {
                      float: right;
                      vertical-align: middle;
                      line-height: 25px;
                      font-size: 20px;
                      width: 20px;
                      height: 21px;
                    }
                    .msg {
                      display: none;
                      z-index: 1000;
                      position: absolute;
                      width: 260px;
                      right: 0;
                      transform: translateX(46%);
                      top: 35px;
                      font-size: 12px;
                      background-color: #474c66;
                      padding: 8px 10px;
                      color: #fff;
                      line-height: 1.5;
                      border-radius: 5px;
                      &.msgShow {
                        display: block;
                      }
                      &.msgHide {
                        display: none;
                      }
                      &::after {
                        content: "";
                        position: absolute;
                        top: -20px;
                        left: 50%;
                        transform: translateX(-50%);
                        height: 0;
                        width: 0;
                        border-top: 10px solid transparent;
                        border-left: 10px solid transparent;
                        border-right: 10px solid transparent;
                        border-bottom: 10px solid #474c66;
                      }
                    }
                  }
                }
              }
              .former {
                > p {
                  margin-bottom: 20px;
                }
                .uploadImgBox {
                  padding: 0 !important;
                  @media (max-width: 1200px) {
                    .el-col-xs-20 {
                      padding: 0 !important;
                    }
                  }
                }
                .headBox {
                  width: 60px;
                  height: 60px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin-right: 0;
                  padding: 0 !important;
                  @media (max-width: 1200px) {
                    display: none;
                  }
                  img {
                    border-radius: 100px;
                  }
                }
              }
              .submitBtn {
                width: 100%;
                margin-top: 30px;
                .el-button {
                  padding: 12px 40px;
                  margin: 0 auto;
                }
              }
            }
            > .category {
              @media (max-width: 1200px) {
                display: none;
              }
              &.fixed {
                position: fixed;
                top: 80px;
              }
              position: absolute;
              left: 700px;
              top: 32px;
              ul {
                max-width: 183px;
                margin: 0;
                padding: 0;
                border-left: 1px solid #e6e8f2;
                list-style-type: none !important;
                list-style: none !important;
                text-align: left;
                li {
                  display: -webkit-box;
                  display: -webkit-flex;
                  display: -moz-box;
                  display: -ms-flexbox;
                  display: flex;
                  align-items: center;
                  margin-left: -1px;
                  padding-left: 12px;
                  border-left: 3px solid transparent;
                  font-weight: bold;
                  font-size: 14px;
                  line-height: 32px;
                  -webkit-box-align: center;
                  -webkit-align-items: center;
                  -moz-box-align: center;
                  -ms-flex-align: center;
                  cursor: pointer;
                  &.active {
                    border-color: #1890ff;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .dialogTopper {
    padding: 0 20px;
    img{
      width: 100px;
    }
    .codeDialog {
      .title {
        text-align: center;
        span {
          padding: 0 20px;
          font-size: 26px;
          display: inline-block;
          color: #06a8ff;
          background-image: linear-gradient(
            transparent 75%,
            rgba(38, 172, 255, 0.28) 55%
          );
          margin-bottom: 30px;
        }
      }
      > .el-row {
        margin-bottom: 10px;
      }
      .telItem,
      .codeItem {
        position: relative;
        i {
          position: absolute;
          left: 5px;
          top: 50%;
          transform: translateY(-50%);
          color: #06a8ff;
          font-size: 20px;
          z-index: 100;
        }
      }
      .code {
        > div {
          vertical-align: middle;
          &:nth-child(1) {
            padding-right: 10px;
          }
          &:nth-child(2) {
            text-align: center;
            line-height: 40px;
            color: fff;
            button {
              border: 1px solid #06a8ff;
              color: #06a8ff;
              vertical-align: middle;
              margin-bottom: 2px;
              width: 100%;
              height: 40px;
              font-size: 12px;
              padding: 0 !important;
              &:nth-child(2) {
                margin-left: 0;
              }
              span {
                i {
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.el-message {
  top: 100px !important;
}
.applyInfo {
  .codeDialog {
    .el-input {
      .el-input__inner {
        padding-left: 30px;
      }
    }
  }
  .el-form-item__label {
    width: 100%;
    text-align: left;
    padding: 0;
  }
  @media screen and (max-width: 768px) {
    .el-dialog {
      width: 90% !important;
    }
  }
  .el-dialog{
    width: 500px;
  }
  .el-dialog__close{
    color: #06a8ff;
    font-size: 30px !important;
  }
  .el-form-item {
    
  }
  .el-dialog__body{
      padding: 30px 20px 0;
    }
  .el-dialog__footer {
    padding: 0 20px 50px;
    button {
      width: 100%;
    }
  }
  .el-select {
    width: 100%;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .el-cascader {
    width: 100%;
  }
  .el-upload__tip {
    margin-top: 0;
    line-height: 1.2;
  }
  .upload-demo {
    text-align: left;
  }
  @media (max-width: 1200px) {
    .el-upload {
      width: 100%;
      .el-upload-dragger {
        width: 100%;
      }
    }
    .uploadImgBox {
      .el-upload__tip {
        text-align: left;
      }
    }
    .el-popper{
      left: 0 !important;
      width: 100%;
    }
  }
}
.el-cascader-panel{
  width: 100%;
}
.el-cascader-menu{
  // width: 33.3%;
  min-width: 33.3%;
}

</style>


// WEBPACK FOOTER //
// src/views/onlineApp/applyInfo.vue